export enum Environment {
  DEV = 'Dev',
  TEST = 'Test',
  UAT = 'UAT',
  PROD = 'Prod',
}
